import React from 'react';
import useTranslation from 'utils/hooks/useTranslation';
import { Typography } from 'antd';

import styles from './style.module.scss';

const CreditAccountRejectedBanner = () => {
  const { translateText } = useTranslation();

  return (
    <div className={styles.rejectedBannerContainer}>
      <section className={styles.rejectedBannerSection}>
        <Typography className={styles.rejectedBannerTitle}>
          {translateText('corporateAccounts.creditAccount.rejectedBanner.title')}
        </Typography>
        <Typography>
          {translateText('corporateAccounts.creditAccount.rejectedBanner.description')}
        </Typography>
      </section>
    </div>
  );
};

export default CreditAccountRejectedBanner;
